/* ==========================================================================
   Scroll Reveal — IntersectionObserver-based scroll animations
   ========================================================================== */

(function () {
	"use strict";

	var STAGGER_DELAY = 100; // ms between each child
	var THRESHOLD = 0.15;
	var ROOT_MARGIN = "0px 0px -50px 0px";

	var STAGGER_CHILD_SELECTORS = [
		".resource-list__item",
		".collection-card",
		".featured-blog-posts-card",
		".blog-post-card",
	].join(",");

	/** @param {Element} section */
	function applyStaggerDelays(section) {
		if (!section.hasAttribute("data-scroll-reveal-stagger")) return;

		var children = section.querySelectorAll(STAGGER_CHILD_SELECTORS);
		for (var i = 0; i < children.length; i++) {
			children[i].style.transitionDelay = i * STAGGER_DELAY + "ms";
		}
	}

	function initScrollReveal() {
		var elements = document.querySelectorAll(
			"[data-scroll-reveal]:not(.is-visible)",
		);
		if (!elements.length) return;

		var observer = new IntersectionObserver(
			function (entries) {
				entries.forEach(function (entry) {
					if (entry.isIntersecting) {
						entry.target.classList.add("is-visible");
						observer.unobserve(entry.target);
					}
				});
			},
			{
				threshold: THRESHOLD,
				rootMargin: ROOT_MARGIN,
			},
		);

		elements.forEach(function (el) {
			applyStaggerDelays(el);
			observer.observe(el);
		});
	}

	// Init on page load
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initScrollReveal);
	} else {
		initScrollReveal();
	}

	// Re-init when Shopify Theme Editor loads a section
	document.addEventListener("shopify:section:load", function () {
		// Small delay to let the DOM settle
		setTimeout(initScrollReveal, 100);
	});
})();
